import { useMutation } from "@tanstack/react-query";
import fetchToBackend, { type BackendError } from "@/utils/fetchToBackend";
import type { ProductSegment, SupplierProducts } from "@/types/domain";

/** Un turno de la conversación con la IA: lo que escribió o lo que ella repreguntó. */
export type SuggestionMessage = {
  role: "user" | "assistant";
  content: string;
};

/**
 * Ordena lo que escribió el usuario en términos buscables: lo que vende el
 * proveedor, las obras que hace el contratista o lo que le vende al Estado. No
 * persiste nada: la línea se guarda al avanzar en el onboarding.
 */
export function useStructureProducts() {
  return useMutation<
    SupplierProducts,
    BackendError,
    { messages: SuggestionMessage[]; segment: ProductSegment }
  >({
    mutationFn: (input) =>
      fetchToBackend<SupplierProducts>("/onboarding/products", {
        method: "POST",
        body: JSON.stringify(input),
      }),
  });
}
